import React from 'react';
import styles from './styles.module.css';

export const Title: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => <h3 className={styles.mainModalTitle}>{children}</h3>;
